import { useState } from "react";
import {Calendar as FullCalendar, type CalendarEvent,} from "@/components/ui/full-calendar/Calendar";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogClose,
} from "@/components/ui/Dialog";
import { Button } from "@/components/ui/Button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/Avatar";
import { useEffect } from "react";
import { TicketStatus, useGetAllListingOfTicketsQuery } from "@/services/LiveQueueService";
import { RootState } from "@/app/store";
import { useSelector } from "react-redux";
import { getStatusColor } from "@/utils/Helper";
import { Loader2 } from "lucide-react";
import { useToast } from "@/components/ui/UseToast";
import useTableData from "@/components/ui/table/DataTableLogic";
import { DatePickerWithRange } from "@/components/ui/DateRangePicker";
import { startOfMonth, endOfMonth, startOfWeek, endOfWeek, startOfDay, format } from "date-fns";

const initialValue = {
  limit: 10,
  offset: 0,
  sort_order: "desc",
  sort_key: "id",
  date_from: "",
  date_to: "",
};
type Facility = {
  id: number;
  name: string;
  color: string;
  selected: boolean;
};
interface TicketAppointmentProps {
  showReservedOnly?: boolean;
  viewMode?: "TicketAppoitment" | "list";
  setViewMode?: React.Dispatch<React.SetStateAction<"TicketAppoitment" | "list">>;
}
export default function TicketAppointment({
  showReservedOnly = false,
  viewMode,
  setViewMode
}: TicketAppointmentProps) {
  const { toast } = useToast();
  const [events, setEvents] = useState<CalendarEvent[]>([]);
  const [selectedEvent, setSelectedEvent] = useState<CalendarEvent | null>(
    null
  );
  const [isViewEventOpen, setIsViewEventOpen] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date>(startOfDay(new Date()));
  //const [selectedDate, setSelectedDate] = useState<Date>(startOfDay(new Date()));  const [searchTerm, setSearchTerm] = useState("");
  const [filterValues, setFilterValues] = useState({
    departmentId: "",
    serviceId: "",
    status: "",
  });

  // Add these state variables
  const [currentView, setCurrentView] = useState<"month" | "week">(
    "month"
  );
  const [dateRange, setDateRange] = useState<{ start: Date; end: Date }>({
    start: new Date(),
    end: new Date(),
  });


  const handleDatePickerChange = (value: {
    start_date: Date | undefined;
    end_date: Date | undefined;
  }) => {
    if (value.start_date && value.end_date) {
      const newRange = {
        start: value.start_date,
        end: value.end_date,
      };
      setDateRange(newRange);

      // Update the query params
      setSearchCriteria({
        ...searchCriteria,
        date_from: formatDateForQuery(newRange.start),
        date_to: formatDateForQuery(newRange.end),
      });
    }
  };
  // Get user info from Redux store
  const userInfo = useSelector((state: RootState) => state.auth.userInfo);

  // Format dates for API query
  const formatDateForQuery = (date: Date) => {
    return format(date, "yyyy-MM-dd"); // stays local
  };

  // Update the initial search criteria
  // const initialSearchCriteria = {
  //   ...initialValue,
  //   date_from: formatDateForQuery(new Date()), // default to today
  //   date_to: formatDateForQuery(new Date()),
  // };
  const initialSearchCriteria = {
    ...initialValue,
    date_from: formatDateForQuery(
      currentView === "month"
        ? startOfMonth(selectedDate)
        : startOfWeek(selectedDate, { weekStartsOn: 1 })
    ),
    date_to: formatDateForQuery(
      currentView === "month"
        ? endOfMonth(selectedDate)
        : endOfWeek(selectedDate, { weekStartsOn: 1 })
    ),
  };

  const { searchCriteria, query, toggleSortOrder, setSearchCriteria } =
    useTableData(initialSearchCriteria);
  const {
    data: ticketsData,
    isLoading: isTicketDataLoading,
    refetch,
    error,
    isError,
  } = useGetAllListingOfTicketsQuery(
    {
      query: `${query}&status=RESERVED`,
    },
    {
      skip: query == "",
    }
  );

  // Convert tickets data to calendar events format
  useEffect(() => {
    if (ticketsData?.data) {
      const calendarEvents: CalendarEvent[] = ticketsData.data.map((ticket) => {
        // Create a date object from the ticket date and time
        const ticketDate = new Date(ticket.date);
        const [hours, minutes] = ticket.time.split(":").map(Number);

        const startTime = new Date(
          `${ticketDate.toISOString().split("T")[0]}T${ticket.time}`
        );
        startTime.setHours(hours, minutes, 0);
        const statusColor = getStatusColor(ticket.status);

        return {
          id: ticket.id.toString(),
          title: ticket.title || `Ticket #${ticket.ticket_id}`,
          start: startTime,
          end: startTime,
          status: ticket.status as TicketStatus, // Add status property to match CalendarEvent type
          statusColor: statusColor,
          ticket_number: ticket.ticket_id || "Unknown",
          user: {
            username: ticket.customer?.username?.toString() || "unknown",
            name: ticket.customer?.name || "Unknown User",
            avatar: "/placeholder.svg",
          },
          description: ticket.description || "No description available",
          location: ticket.service?.department_name || "Department",
          originalTicket: ticket, // Store the original ticket data for reference
        };
      });

      console.log("calendarEvents", calendarEvents);
      setEvents(calendarEvents);
    }
  }, [ticketsData]);

  const handleCreateEvent = () => {
    toast({
      title: "Create New Ticket",
      description: "This feature will be implemented in the next update.",
    });
  };

  const handleViewEvent = (event: CalendarEvent) => {
    setSelectedEvent(event);
    setIsViewEventOpen(true);
  };

  const handleDateChange = (date: Date | undefined) => {
    if (date) {
      setSelectedDate(date);
    }
  };

  const handleFilterEvents = () => {
    setIsFilterOpen(true);
  };

  const applyFilters = () => {
    refetch();
    setIsFilterOpen(false);
  };
 console.log("selected Days one",selectedDate)
  const formatDate = (date: Date | string) => {
    const dateObj = typeof date === "string" ? new Date(date) : date;
    return dateObj.toLocaleString("en-PK", {
      weekday: "short",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };

  const handleDateRangeChange = (range: { start: Date; end: Date }) => {
    setDateRange(range);

    // Update the query with new date range
    const from = formatDateForQuery(range.start);
    const to = formatDateForQuery(range.end);

    setSearchCriteria({
      ...searchCriteria,
      date_from: from,
      date_to: to,
    });
      // setSelectedDate(
      //   new Date((range.start.getTime() + range.end.getTime()) / 2)
      // );
        const midpointDate = new Date(
          (range.start.getTime() + range.end.getTime()) / 2
        );
        setSelectedDate(
          new Date(
            midpointDate.getFullYear(),
            midpointDate.getMonth(),
            midpointDate.getDate(),
            12,
            0,
            0
          )
        );
  };
useEffect(() => {
  // Set initial date range based on current view
  let initialRange: { start: Date; end: Date };
  if (currentView === "month") {
    initialRange = {
      start: startOfMonth(selectedDate),
      end: endOfMonth(selectedDate),
    };
  } else {
    initialRange = {
      start: startOfWeek(selectedDate, { weekStartsOn: 1 }),
      end: endOfWeek(selectedDate, { weekStartsOn: 1 }),
    };
  }

  setDateRange(initialRange);

  setSearchCriteria({
    ...searchCriteria,
    date_from: formatDateForQuery(initialRange.start),
    date_to: formatDateForQuery(initialRange.end),
  });
}, []);
  const handleViewChange = (view: "month" | "week") => {
    setCurrentView(view);

    // Calculate new date range based on view
    let newRange: { start: Date; end: Date };
    if (view === "month") {
      newRange = {
        start: startOfMonth(selectedDate),
        end: endOfMonth(selectedDate),
      };
    } else {
      // week view
      newRange = {
        start: startOfWeek(selectedDate, { weekStartsOn: 1 }), // weekStartsOn: 1 means Monday
        end: endOfWeek(selectedDate, { weekStartsOn: 1 }),
      };
    }

    setDateRange(newRange);

    // Update search criteria
    setSearchCriteria({
      ...searchCriteria,
      date_from: formatDateForQuery(newRange.start),
      date_to: formatDateForQuery(newRange.end),
    });
  };

  // const handleDatePickerChange = (range: { start_date: Date; end_date: Date }) => {
  //   setDateRange({ start: range.start_date, end: range.end_date });
  //   handleDateRangeChange({ start: range.start_date, end: range.end_date });
  // };

  // Update useEffect to refetch when date range changes
 

  return (
    <div className="flex flex-col md:flex-row gap-6 p-5">
      {/* Main content */}
      <div className="relative w-full rounded-lg bg-white">
      {/* {viewMode==="TicketAppoitment" &&<div className="mb-4 flex justify-between items-center">
          <DatePickerWithRange
            name="date-range"
            value={{
              start_date: dateRange.start,
              end_date: dateRange.end
            }}
            onValueChange={handleDatePickerChange}
            label="Select date range"
            className="w-[300px]"
          />
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium">View:</span>
            <select 
              className="px-2 py-1 border rounded-md text-sm"
              value={currentView}
              onChange={(e) => handleViewChange(e.target.value as "month" | "week")}
            >
              <option value="month">Month</option>
              <option value="week">Week</option>
            </select>
          </div>
        </div>} */}
        
        {isTicketDataLoading ? (
          <div className="flex items-center justify-center h-[600px]">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <span className="ml-2">Loading tickets...</span>
          </div>
        ) : isError ? (
          <div className="flex items-center justify-center h-[600px] text-red-500">
            Error loading tickets. Please try again.
          </div>
        ) : (
          <div className="flex-1">
            <FullCalendar
              events={events}
              initialView={currentView}
              initialDate={new Date()}
              onCreateEvent={handleCreateEvent}
              onViewEvent={handleViewEvent}
              onFilterEvents={handleFilterEvents}
              onDateRangeChange={handleDateRangeChange}
              onViewChange={handleViewChange}
              setView={setViewMode}
            />
          </div>
        )}
        <Dialog open={isViewEventOpen} onOpenChange={setIsViewEventOpen}>
          <DialogContent className="sm:max-w-[500px]">
            <DialogHeader>
              <DialogTitle>{selectedEvent?.title}</DialogTitle>
            </DialogHeader>
            {selectedEvent && (
              <div className="py-4">
                <div className="grid gap-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <span className="font-medium">Date:</span>
                      <span className="ml-2">
                        {formatDate(selectedEvent.start)}
                      </span>
                    </div>
                  </div>

                  {selectedEvent.description && (
                    <div>
                      <span className="font-medium">Description:</span>
                      <p className="mt-1 text-sm text-gray-600">
                        {selectedEvent.description}
                      </p>
                    </div>
                  )}

                  {selectedEvent.user && (
                    <div className="flex items-center">
                      <span className="font-medium">Customer:</span>
                      <div className="flex items-center ml-2">
                        <Avatar className="h-5 w-5 mr-1">
                          <AvatarImage
                            src={selectedEvent.user.avatar || ""}
                            alt={selectedEvent.user.name}
                          />
                          <AvatarFallback>
                            {selectedEvent.user.name.charAt(0)}
                          </AvatarFallback>
                        </Avatar>
                        <span>{selectedEvent.user.name}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
            <DialogFooter>
              <DialogClose asChild>
                <Button>Close</Button>
              </DialogClose>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
}
